<template>
  <div>
    <div class="d-flex justify-start mt-5 pl-16" v-if="seconds">
      <div>
        <h2>{{ countdown }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "CountDown",
  props: {
    seconds: {
      type: Number,
      required: true,
    },
    testFinalizado:{
        type:Boolean,
        required:true,
        default:false,
    }
  },
  data() {
    return {
      countdown: null,
      expires_in: null,
      interval: null,
      tiempoFinalizado: 1,
    };
  },
   watch: {
    // cada vez que la seconds cambie, esta función será ejecutada
    seconds: function (newSeconds) {
      this.expires_in = newSeconds;
    }
  },
  mounted() {
    
    if (this.testFinalizado == false) {
    this.countdown = moment.utc(this.seconds).format("HH:mm:ss");
    this.expires_in = this.seconds;
    this._setInterval();
    }
  },
  updated(){
    if (this.seconds == 0) {
      this.expires_in = 0
    }
    
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    _setInterval: function () {
      this.interval = setInterval(() => {
        if (this.expires_in === 0) {
          clearInterval(this.interval);

        if (this.testFinalizado == false) {
          this.$emit("siguientePregunta", this.tiempoFinalizado);
          this.countdown = null;
          this.expires_in = null;
          this.interval = null;
          // Antes se rearmaba con iniciarReloj(): si `seconds` era 0 (examen mal
          // configurado, tiempo_examen 0 o null) volvia a emitir cada segundo y
          // machacaba guardar-respuestas para siempre. Se emite una sola vez.
        }

        } else {
          this.expires_in -= 1;
          this.countdown = moment
            .utc(this.expires_in * 1000)
            .subtract(1, "seconds")
            .format("HH:mm:ss");
        }
      }, 1000);
    },
  },
};
</script>